<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4C20B/4C20B.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4C20B 2.0T汽油机</div>
        <div class="detail-banner-desc">
          核心技术：电控废气阀双流道增压器、350bar电喷系统、缸盖集成排气歧管技术、进排气双VVT、热管理模块。
        </div>
      </div>
    </div>
    <div class="detail-box ">
      <div class="detail-title">核心参数</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率（N·m）</div>
          <div class="detail-utils-u">165/5500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩（kW）</div>
          <div class="detail-utils-u">385/1800-3600rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排量（L）</div>
          <div class="detail-utils-u">1.967</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最低油耗率（g/kWh）</div>
          <div class="detail-utils-u">229</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国VI b</div>
        </div>

      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">热管理模块</div>
          <div class="detail-four-desc">
            采用电控热管理模块，保证冷却液快速升温，节省升温时间5分钟；智能调节和控制发动机的温度，确保其在各种工况下都能高效、稳定地运行。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">缸盖集成排气歧管</div>
          <div class="detail-four-desc">
            集成排气歧管，有效降低整机重量；<br />在热机过程中，充分利用排气能量提升水温，减少热机时间，改善燃油耗及排放；<br />在大负荷工况，增加集排水套可降低排气温度，减少喷油加浓区域，提升燃油经济性和降低排放。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <!-- <div class="detail-title">低油耗</div>
					<div class="detail-desc">200 g/kW.h燃油消耗率，创造省油新高度</div> -->
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">电控废气阀双流道增压器</div>
          <div class="detail-updown-desc">
            双流道涡壳，减小废气脉冲干扰，提高响应性；6大6小全机加压轮，消除BPF哨音；电控废气阀，控制精度高，提高动态响应。较上一代产品转动惯量降低27%、压端效率提升3%、涡端效率提升5%，动力响应性提高60%。
          </div>
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">燃油喷射系统</div>
          <div class="detail-updown-desc">
            350bar燃油喷射系统，改善燃油雾化效果，油气混合更加均匀，有效降低发动机降低排放水平；<br />
            喷孔采用激光钻孔，改善燃油雾化效果，减小贯穿距，降低排放；<br />
            独立的油束油孔设计更加灵活，孔径不同大小，提高混合气的均质化程度；喷油器支持3次喷射，喷油控制更加灵活。</div>
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4C20B/4C20B-5.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            正时系统
          </div>
          <div class="detail-desc">
            支持进排气双VVT技术，优化燃烧、降低油耗、提升扭矩、降低排放。
          </div>
        </div>

      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4C20B 2.0T汽油机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4C20B.html'
};

import { createApp } from 'vue';
import App from './4C20B.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4C20B.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>